/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreatePartnerGroupDto } from '../models/CreatePartnerGroupDto';
import type { OrderBy } from '../models/OrderBy';
import type { UpdatePartnerGroupDto } from '../models/UpdatePartnerGroupDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class AdminPartnerGroupService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Create partner group
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    public partnerGroupAdminControllerCreate(
        requestBody: CreatePartnerGroupDto,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/admin/partner-group',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Get all partner group
     * @param limit
     * @param page
     * @param orderBy
     * @param sort
     * @param name
     * @param countryId
     * @param regionId
     * @param sectorId
     * @returns any
     * @throws ApiError
     */
    public partnerGroupAdminControllerGetAll(
        limit?: string,
        page?: string,
        orderBy?: string,
        sort?: OrderBy,
        name?: string,
        countryId?: string,
        regionId?: string,
        sectorId?: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/admin/partner-group',
            query: {
                'limit': limit,
                'page': page,
                'order_by': orderBy,
                'sort': sort,
                'name': name,
                'country_id': countryId,
                'region_id': regionId,
                'sector_id': sectorId,
            },
        });
    }

    /**
     * Get detail partner group
     * @param id
     * @returns any
     * @throws ApiError
     */
    public partnerGroupAdminControllerGetDetail(
        id: number,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/admin/partner-group/{id}',
            path: {
                'id': id,
            },
        });
    }

    /**
     * Update partner group
     * @param id
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    public partnerGroupAdminControllerUpdate(
        id: number,
        requestBody: UpdatePartnerGroupDto,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/api/admin/partner-group/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Delete partner group
     * @param id
     * @returns any
     * @throws ApiError
     */
    public partnerGroupAdminControllerDelete(
        id: number,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/admin/partner-group/{id}',
            path: {
                'id': id,
            },
        });
    }

}
